export default __webpack_public_path__ + "static/media/go.2eee858b.jpg";